/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { BorderRadiuses } from "@/tokens/border";
import { Colors } from "@/tokens/color";
import { Spacing } from "@/tokens/spacing";

import { GridColumn } from "@/ui/atoms/grid_column";
import { Text } from "@/ui/atoms/text";

import { useTypedTheme } from "@/util/hooks/theme_hooks";
import { RenderLocation } from "@/util/tokens/render_location_util";
import { getTrackEvent } from "@/util/tokens/track_event_util";

import { NestedForm } from "./nested_form";

export const DownloadMobileForm = () => {
    /**
     * Globals
     */
    const renderLocation = RenderLocation.DOWNLOAD_PAGE;
    const theme = useTypedTheme();

    /**
     * Styles
     */
    const waitlistComponentWrapperStyles = css({
        background: Colors[theme.backgrounds.backgroundSecondary],
        borderRadius: BorderRadiuses.borderMedium,
        marginBottom: Spacing["spacing-6"],
        padding: Spacing["spacing-6"],
    });

    /**
     * Rendering
     */
    return (
        <GridColumn
            className={waitlistComponentWrapperStyles}
            columnSpan={{
                extraSmall: "full",
                medium: 8,
                large: 6,
            }}
            columnStart={{
                extraSmall: 1,
                medium: 3,
                large: 4,
            }}
        >
            <Text
                fontSize="DownloadMobileCardTitle"
                marginBottom="DownloadMobileCardHeading"
                shouldBalanceWrap={true}
                tag="h2"
                textAlign="center"
                themeKey="textPrimary"
            >
                On a mobile device? Send Warp to your work station.
            </Text>

            <Text
                fontSize="DownloadMobileCardSubtitle"
                marginBottom="LongformHeadlineDefault"
                shouldBalanceWrap={true}
                textAlign="center"
                themeKey="textSecondary"
            >
                You can’t use Warp on the go (yet). In the meantime, we’ll email
                you a download link for later.
            </Text>

            <NestedForm
                formEndpoint={process.env.NEXT_PUBLIC_SEND_DOWNLOAD_ENDPOINT!}
                formName="Mobile Download Form"
                placeholder="Enter your email"
                shouldStackInputAndButton={true}
                submitText="Send download link"
                track={{
                    inputFocus: getTrackEvent(
                        "SEND_DOWNLOAD_EMAIL_INPUT_FOCUSED",
                        { location: renderLocation },
                    ),
                    submissionResult: getTrackEvent(
                        "SEND_DOWNLOAD_FORM_SUBMISSION_RESULT",
                        {
                            location: renderLocation,
                        },
                    ),
                    submissionStarted: getTrackEvent(
                        "SEND_DOWNLOAD_FORM_SUBMISSION_STARTED",
                        {
                            location: renderLocation,
                        },
                    ),
                }}
            />
        </GridColumn>
    );
};
